<template>
<div class="chapter">
<div class="inner_page">
<p class="fm_centery"><a id="page_1">SOUTH WALES VALLEYS SERIES</a></p><a id="page_1">
<h1 class="fm_title">Railways and Industry in the</h1>
</a><h1 class="fm_title1"><a id="page_1">TONDU VALLEYS</a><a id="page_2"></a></h1><a id="page_2">
<p class="sub_image"><img alt="Image" src="images/halftitle.jpg"/></p>
<div class="img_container">
<img alt="image" src="images/f0001-01.jpg"/>
</div>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Halftitle.vue?e04d953a